var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIngredients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 99.996,
    viewBox: "0 0 100 99.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.584,51.391V33.867l-10.3-4.73C42.859,42.727,38.59,78.125,10.938,78.125a10.937,10.937,0,1,0,0,21.875c41.531,0,72.393-24,81.871-41.082l-7.236-7.527Zm25.6-25.072C96.469,14.631,93.2,5.172,89.574.586a1.562,1.562,0,0,0-2.33-.115L82.771,4.963a1.574,1.574,0,0,0-.174,2c1.34,2.023,3.33,6.855-.273,14.125A27.585,27.585,0,0,0,56.25,23.162l14.584,6.7V45.141h17.4L98.914,56.25A30.513,30.513,0,0,0,100,48.572a30.078,30.078,0,0,0-9.813-22.254Z",
    transform: "translate(0 -0.004)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngredients);
export default __webpack_public_path__ + "static/media/ingredients.7d0587b84e35528f04d2b5ee31b11744.svg";
export { ForwardRef as ReactComponent };